import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/` has no page of its own: super admins go to `/a`, restaurant users to `/r`. */
export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    if (context.convexUser.userType === 'superAdmin') throw redirect({ to: '/a' });
    if (context.convexUser.userType === 'restaurantUser') throw redirect({ to: '/r' });
  },
});
